import React from 'react';
import styles from './DataGrid.module.css';
import { DataGridColumn } from './types';

const cx = (...classes: (string | false | null | undefined)[]) =>
  classes.filter(Boolean).join(' ');

interface SkeletonRowProps {
  columns: DataGridColumn<object>[];
  showIndex?: boolean;
  selectable?: boolean;
}

export function SkeletonRow({ columns, showIndex, selectable }: SkeletonRowProps) {
  return (
    <tr className={styles.skeletonRow} aria-hidden="true">
      {selectable && <td className={cx(styles.cell, styles.checkboxCell)} />}
      {showIndex && <td className={cx(styles.cell, styles.indexCell)} />}
      {columns.map(col => (
        <td key={col.key} className={styles.cell}>
          <span className={styles.skeleton} />
        </td>
      ))}
    </tr>
  );
}
